import React, { Component } from 'react';
import { PackageIcon, PlusIcon, ShieldCheckIcon, CarIcon, HomeIcon, BriefcaseIcon, SettingsIcon, PowerIcon } from 'lucide-react';
import { formatNaira } from '../../utils/format';
export function BundleModule({
  role
}: {
  role: string;
}) {
  const bundles = [{
    id: 'BND-001',
    name: 'Skydd Complete Protection',
    description: 'The ultimate bundle for comprehensive lifestyle protection.',
    pricingModel: 'Sum of Components with Discount (15%)',
    status: 'Active',
    purchases: 1245,
    components: [{
      name: 'AutoGuard',
      icon: CarIcon,
      color: 'indigo'
    }, {
      name: 'Property Shield',
      icon: HomeIcon,
      color: 'amber'
    }, {
      name: 'Income Shield',
      icon: BriefcaseIcon,
      color: 'blue'
    }],
    tiers: [{
      name: 'Bronze',
      price: 18500
    }, {
      name: 'Silver',
      price: 35000
    }, {
      name: 'Gold',
      price: 75000
    }]
  }, {
    id: 'BND-002',
    name: 'Family Starter Pack',
    description: 'Essential protection for new families.',
    pricingModel: 'Fixed Bundle Price',
    status: 'Draft',
    purchases: 0,
    components: [{
      name: 'Future Scholar Fund',
      icon: ShieldCheckIcon,
      color: 'emerald'
    }, {
      name: 'Wellness Plan',
      icon: ShieldCheckIcon,
      color: 'cyan'
    }],
    tiers: [{
      name: 'Standard',
      price: 25000
    }, {
      name: 'Premium',
      price: 50000
    }]
  }];
  return <div className="space-y-6" data-id="element-147">
      <div className="flex justify-between items-center" data-id="element-148">
        <div data-id="element-149">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-150">Bundle Manager</h2>
          <p className="text-sm text-gray-500" data-id="element-151">
            Package multiple products into unified offerings.
          </p>
        </div>
        <button className="bg-[#0D3B3B] text-white px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-[#092D2D] transition-colors" data-id="element-152">
          <PlusIcon className="w-4 h-4" data-id="element-153" /> Create Bundle
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-154">
        {bundles.map(bundle => <div key={bundle.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-155">
            <div className="p-6 border-b border-gray-100" data-id="element-156">
              <div className="flex justify-between items-start mb-4" data-id="element-157">
                <div className="w-12 h-12 rounded-xl bg-purple-50 flex items-center justify-center text-purple-600" data-id="element-158">
                  <PackageIcon className="w-6 h-6" data-id="element-159" />
                </div>
                <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${bundle.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'}`} data-id="element-160">
                  {bundle.status}
                </span>
              </div>
              <h3 className="font-bold text-[#0D3B3B] text-xl mb-1" data-id="element-161">
                {bundle.name}
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-162">{bundle.description}</p>

              <div className="flex -space-x-2 mb-6" data-id="element-163">
                {bundle.components.map((comp, idx) => <div key={idx} className={`w-10 h-10 rounded-full border-2 border-white bg-${comp.color}-50 flex items-center justify-center text-${comp.color}-600 z-${30 - idx * 10}`} title={comp.name} data-id="element-164">
                    <comp.icon className="w-4 h-4" data-id="element-165" />
                  </div>)}
                <div className="w-10 h-10 rounded-full border-2 border-white bg-gray-50 flex items-center justify-center text-xs font-bold text-gray-500 z-0" data-id="element-166">
                  +{bundle.components.length}
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-3" data-id="element-167">
                <p className="text-[10px] uppercase font-bold text-gray-400 tracking-wider mb-1" data-id="element-168">
                  Pricing Model
                </p>
                <p className="text-xs font-bold text-[#0D3B3B]" data-id="element-169">
                  {bundle.pricingModel}
                </p>
              </div>
            </div>

            <div className="p-6 bg-gray-50/50" data-id="element-170">
              <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-171">
                Bundle Tiers (Monthly)
              </h4>
              <div className="space-y-2 mb-6" data-id="element-172">
                {bundle.tiers.map((tier, idx) => <div key={idx} className="flex justify-between items-center bg-white p-3 rounded-xl border border-gray-100" data-id="element-173">
                    <span className="text-sm font-bold text-[#0D3B3B]" data-id="element-174">
                      {tier.name}
                    </span>
                    <span className="text-sm font-bold text-[#2BA89D]" data-id="element-175">
                      {formatNaira(tier.price)}
                    </span>
                  </div>)}
              </div>

              <div className="flex gap-2" data-id="element-176">
                <button className="flex-1 bg-white hover:bg-gray-50 text-[#0D3B3B] font-bold py-2.5 rounded-xl text-sm flex items-center justify-center gap-2 transition-colors border border-gray-200" data-id="element-177">
                  <SettingsIcon className="w-4 h-4" data-id="element-178" /> Configure
                </button>
                {role === 'Super Admin' && <button className={`p-2.5 rounded-xl border transition-colors ${bundle.status === 'Active' ? 'bg-rose-50 border-rose-100 text-rose-600 hover:bg-rose-100' : 'bg-emerald-50 border-emerald-100 text-emerald-600 hover:bg-emerald-100'}`} data-id="element-179">
                    <PowerIcon className="w-5 h-5" data-id="element-180" />
                  </button>}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}